import { combineReducers } from "redux";
import { csvImportReducer } from "./csv_import_reducer";

export const importsReducer = combineReducers({
  csvImport: csvImportReducer
});
